import React from 'react';
import { Wifi, WifiOff, RefreshCw, Check } from 'lucide-react';
import { useSyncManager, SYNC_STATUS } from '../context/SyncContext';

const DataHealthIndicator = ({ showLabel = true, size = 'default' }) => {
  const { syncStatus, lastSyncTime, forceResync } = useSyncManager();
  
  const sizeClasses = {
    small: 'text-xs gap-1',
    default: 'text-sm gap-1.5',
    large: 'text-base gap-2'
  };
  
  const iconSizes = {
    small: 'w-3 h-3',
    default: 'w-4 h-4',
    large: 'w-5 h-5'
  };
  
  const getStatusConfig = () => {
    switch (syncStatus) {
      case SYNC_STATUS.LIVE:
        return {
          icon: <Wifi className={`${iconSizes[size]} text-green-500`} />,
          label: 'Live',
          bgColor: 'bg-green-50',
          textColor: 'text-green-700',
          borderColor: 'border-green-200',
          pulseColor: 'bg-green-500'
        };
      case SYNC_STATUS.SYNCING:
        return {
          icon: <RefreshCw className={`${iconSizes[size]} text-blue-500 animate-spin`} />,
          label: 'Syncing...',
          bgColor: 'bg-blue-50',
          textColor: 'text-blue-700',
          borderColor: 'border-blue-200',
          pulseColor: 'bg-blue-500'
        };
      case SYNC_STATUS.DISCONNECTED:
      default:
        return {
          icon: <WifiOff className={`${iconSizes[size]} text-red-500`} />,
          label: 'Disconnected',
          bgColor: 'bg-red-50',
          textColor: 'text-red-700',
          borderColor: 'border-red-200',
          pulseColor: 'bg-red-500'
        };
    }
  };
  
  const config = getStatusConfig();
  
  const formatLastSync = () => {
    if (!lastSyncTime) return '';
    const now = new Date();
    const diff = Math.floor((now - lastSyncTime) / 1000);
    
    if (diff < 5) return 'tani';
    if (diff < 60) return `${diff}s më parë`;
    if (diff < 3600) return `${Math.floor(diff / 60)}m më parë`;
    return `${Math.floor(diff / 3600)}h më parë`;
  };
  
  return (
    <div 
      className={`inline-flex items-center ${sizeClasses[size]} px-2.5 py-1 rounded-full border ${config.bgColor} ${config.borderColor} cursor-pointer hover:opacity-80 transition-opacity`}
      onClick={forceResync}
      title={`Kliko për të ri-sinkronizuar. Sinkronizimi i fundit: ${formatLastSync()}`}
    >
      {/* Pulse indicator for live status */}
      {syncStatus === SYNC_STATUS.LIVE && (
        <span className="relative flex h-2 w-2">
          <span className={`animate-ping absolute inline-flex h-full w-full rounded-full ${config.pulseColor} opacity-75`}></span>
          <span className={`relative inline-flex rounded-full h-2 w-2 ${config.pulseColor}`}></span>
        </span>
      )}
      
      {syncStatus !== SYNC_STATUS.LIVE && config.icon}
      
      {showLabel && (
        <span className={`font-medium ${config.textColor}`}>
          {config.label}
        </span>
      )}
    </div>
  );
};

export default DataHealthIndicator;
